var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPartsNoseOn = function SvgPartsNoseOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF540F",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.967 25.666a.57.57 0 0 1-.564-.48c0-.006-.232-1.18-1.862-2.924-1.212-1.297-2.4-2.84-2.019-4.455.302-1.28 1.51-2.298 3.692-3.11 5.54-2.062 9.234-8.121 9.27-8.182a.572.572 0 0 1 .98.588c-.157.263-3.929 6.461-9.851 8.665-1.772.66-2.774 1.434-2.978 2.301-.257 1.09.736 2.337 1.741 3.413 1.867 1.997 2.132 3.372 2.156 3.522a.57.57 0 0 1-.565.662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.192 25.476a.38.38 0 0 1-.38-.37c-.062-1.955-3.472-2.679-3.506-2.686a.38.38 0 1 1 .153-.746c.165.034 4.033.858 4.114 3.409a.38.38 0 0 1-.37.393zM9.524 8.714a.38.38 0 0 1-.381-.381V7.57a.381.381 0 0 1 .762 0v.762c0 .21-.17.38-.381.38M8.38 9.857H7.62a.381.381 0 0 1 0-.762h.762a.381.381 0 0 1 0 .762"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.095 10.667a4.571 4.571 0 1 1 0-9.143 4.571 4.571 0 0 1 0 9.143M5.133 8.7 2.868 6.435l.68-.68L5.133 7.34l3.51-3.51.68.68z"
  }))));
};
export default SvgPartsNoseOn;